export interface ITrip {
  id: number;
  media: any;
  medias: any;
  archiveLink: string;
  title: string;
  startDate: Date;
  endDate: Date;
  description: string;
  extract: string;
  publishedAt: string;
}

export const Trip = (data: { id: number; attributes: any }): any => {
  return {
    id: data.id,
    title: data.attributes.title,
    description: data.attributes.description,
    extract: data.attributes.extract,
    media: data.attributes.media,
    medias: data.attributes.medias,
    archiveLink: data.attributes.archiveLink,
    startDate: data.attributes.startDate
      ? new Date(data.attributes.startDate)
      : null,
    endDate: data.attributes.endDate ? new Date(data.attributes.endDate) : null,
    publishedAt: data.attributes.publishedAt
      ? new Date(data.attributes.publishedAt)
      : null,
  };
};
